import { useEffect, useState } from "react";
import { webUrlNode } from "../../constants/appInfo";
import { CreditPackUI } from "./CreditPackUI";
import { useSelector } from "react-redux";
  import { useHistory,} from "react-router-dom";
export default function AdminCreditPacks() {
 const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
      const history = useHistory();
 if(!appToken){
 
 
      history.push(`/apps`);
 }
  const [packs,setPacks] = useState([]);

  useEffect(()=>{load()},[]);

  async function load(){
    
    const r = await fetch(`${webUrlNode}/api/admin/credits/packs?appToken=${appToken}&currentToken=${currentToken}`);
   const j = await r.json();
    setPacks(j.length?j : []);
  }

  async function save(p){
    await fetch(`${webUrlNode}/api/admin/credits/packs/${p.id}?appToken=${appToken}&currentToken=${currentToken}`,{
      method:"PATCH",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify(p)
    });
    load();
  }

  async function toggle(p){
    await fetch(`${webUrlNode}/api/admin/credits/packs/${p.id}/status?appToken=${appToken}&currentToken=${currentToken}`,{
      method:"PATCH",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({
        isActive: p.isActive==="true"?"false":"true"
      })
    });
    load();
  }

  return (<div style={styles.wrapper}>

      <h2 style={styles.heading}>Manage Credit Packs</h2>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th>Channel</th>
              <th>Name</th>
              <th>Credits</th>
              <th>Amount (₹)</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {packs.map(p => (
              <CreditPackUI p={p} toggle={toggle} save={save}  />
            ))}
          </tbody>
        </table>
      </div>
<style>
        {`
        
table th {background:#f9f9f9; padding:10px}
         
table td {background:#ffffff; padding:10px}
        `} </style>
    </div>
  );
}
const styles = {
  wrapper: {
    padding: 30,
    background: "#f8fafc",
   
    fontFamily: "Inter, sans-serif"
  },

  heading: {
    marginBottom: 20,
    fontSize: 22,
    fontWeight: 700
  },

  tableWrapper: {
    overflowX: "auto",
    background: "#ffffff",
    borderRadius: 14,
    boxShadow: "0 6px 25px rgba(0,0,0,0.05)"
  },

  table: {
    width: "100%",textAlign:"center",
    borderCollapse: "collapse",
    minWidth: 800
  },

  input: {
    padding: "6px 8px",
    borderRadius: 6,
    border: "1px solid #e5e7eb",
    width: "100%"
  },

  actions: {
    display: "flex",
    gap: 8
  },

  saveBtn: {
    padding: "6px 12px",
    borderRadius: 8,
    border: "none",
    background: "#4f46e5",
    color: "#fff",
    cursor: "pointer",
    fontWeight: 600
  },

  toggleBtn: {
    padding: "6px 12px",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer"
  }
};